module.exports = __webpack_public_path__ + "img/img_divider.0ad5e77c.png";